function SavvySLogo({ height, width }: { readonly height: number; readonly width: number }) {
  return (
    <svg width={width} height={height} viewBox="0 0 165 164" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_476_1054)">
        <path
          d="M82.4998 50.5236C55.3319 50.5236 30.027 59.8556 14.8992 75.1213C11.2596 69.429 9.24142 63.1847 9.24142 56.6299C9.24142 30.1693 42.1016 8.62472 82.4998 8.62472C122.898 8.62472 155.758 30.152 155.758 56.6299H164.383C164.4 25.4084 127.659 0 82.4998 0C37.3408 0 0.616699 25.4084 0.616699 56.6299C0.616699 87.8514 37.358 113.26 82.4998 113.26C109.668 113.26 134.973 103.928 150.1 88.6621C153.74 94.3545 155.758 100.599 155.758 107.154C155.758 133.614 122.898 155.159 82.4998 155.159C42.1016 155.159 9.24142 133.614 9.24142 107.154H0.616699C0.616699 138.375 37.358 163.783 82.4998 163.783C127.642 163.783 164.383 138.375 164.383 107.154C164.383 75.932 127.642 50.5236 82.4998 50.5236ZM82.4998 104.635C56.2634 104.635 33.2181 95.5447 20.2811 81.9349C33.6839 67.8076 57.1086 59.1483 82.4998 59.1483C107.891 59.1483 131.781 68.2388 144.719 81.8486C131.316 95.9759 107.891 104.635 82.4998 104.635Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_476_1054">
          <rect width="163.783" height="163.783" fill="white" transform="translate(0.617188)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SavvySLogo;
